/* ============================================================
   WiseBond Floors — theme.js
   Cart drawer, predictive search, variant picker, sticky ATC,
   swatches, qty steppers, mobile menu. Vanilla, no deps.
   ============================================================ */
(function () {
  'use strict';
  var routes = window.wbRoutes || {};
  var strings = window.wbStrings || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = window.wbMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = (cents / 100).toFixed(2).split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    function repl(match, p1) {
      switch (p1) {
        case 'amount': return withCommas + '.' + parts[1];
        case 'amount_no_decimals': return withCommas;
        case 'amount_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default: return withCommas + '.' + parts[1];
      }
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, repl);
  }
  window.wbFormatMoney = formatMoney;

  /* ---------- header: mobile menu + search ---------- */
  function initHeader() {
    var burger = $('#wb-burger');
    var menu = $('#wb-mobile-menu');
    var overlay = $('#wb-overlay');
    if (burger && menu) {
      burger.addEventListener('click', function () { menu.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); });
      $$('.wb-mobile-close, #wb-mobile-menu a').forEach(function (el) {
        el.addEventListener('click', function () { menu.classList.remove('is-open'); });
      });
    }
    var searchToggle = $('#wb-search-toggle');
    var searchPop = $('#wb-search-pop');
    if (searchToggle && searchPop) {
      searchToggle.addEventListener('click', function () {
        var open = searchPop.classList.toggle('is-open');
        if (open) { var inp = $('.wb-search-input', searchPop); if (inp) inp.focus(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') searchPop.classList.remove('is-open'); });
    }
  }

  /* ---------- predictive search ---------- */
  function initPredictive() {
    var form = $('#wb-search-pop .wb-search-form');
    if (!form || !routes.predictive_search_url) return;
    var input = $('.wb-search-input', form);
    var results = $('#wb-predictive');
    if (!input || !results) return;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () { runPredictive(q, results); }, 220);
    });
  }
  function runPredictive(q, results) {
    var url = routes.predictive_search_url + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,page,article&resources[limit]=6&section_id=predictive-search';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      // section render returns full section; extract inner
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('#wb-predictive-inner');
      results.innerHTML = inner ? inner.innerHTML : '';
    }).catch(function () {});
  }

  /* ---------- cart drawer ---------- */
  var drawer, overlay;
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); } var mm = $('#wb-mobile-menu'); if (mm) mm.classList.remove('is-open'); }

  function renderCart(cart) {
    var count = cart.item_count;
    $$('.wb-cart-count').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
    var body = $('#wb-drawer-body');
    var foot = $('#wb-drawer-foot');
    if (!body) return;
    if (count === 0) {
      body.innerHTML = '<div class="wb-drawer-empty"><div><p style="font-size:18px;margin-bottom:18px;color:var(--wb-ink)">Your cart is empty</p><button class="wb-btn wb-btn-dark wb-drawer-close-x">Continue shopping</button></div></div>';
      if (foot) foot.style.display = 'none';
      bindDrawerClose();
      return;
    }
    if (foot) foot.style.display = '';
    var html = '';
    cart.items.forEach(function (it, i) {
      var variant = (it.options_with_values || []).map(function (o) { return o.value; }).join(' · ');
      if (!variant && it.variant_title && it.variant_title !== 'Default Title') variant = it.variant_title;
      html += '<div class="wb-line" data-key="' + it.key + '">' +
        '<a href="' + it.url + '"><img src="' + (it.image ? it.image.replace(/(\.[^.]+)(\?|$)/, '_160x160$1$2') : '') + '" alt="" loading="lazy"></a>' +
        '<div><div class="wb-line-title"><a href="' + it.url + '">' + it.product_title + '</a></div>' +
        (variant ? '<div class="wb-line-variant">' + variant + '</div>' : '') +
        '<div class="wb-line-bottom"><div class="wb-qty" data-key="' + it.key + '">' +
        '<button type="button" data-step="-1" aria-label="Decrease">&minus;</button>' +
        '<input type="text" value="' + it.quantity + '" inputmode="numeric" data-line-qty readonly>' +
        '<button type="button" data-step="1" aria-label="Increase">+</button></div>' +
        '<button class="wb-line-remove" data-remove="' + it.key + '">Remove</button></div></div>' +
        '<div class="wb-line-price">' + formatMoney(it.final_line_price) + '</div></div>';
    });
    body.innerHTML = html;
    // subtotal
    var sub = $('#wb-drawer-subtotal'); if (sub) sub.textContent = formatMoney(cart.total_price);
    // free shipping bar
    updateShipBar(cart.total_price);
    bindDrawerLines();
  }

  function updateShipBar(total) {
    var bar = $('#wb-ship-bar');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) * 100;
    if (!threshold || threshold <= 0) { bar.style.display = 'none'; return; }
    var fill = $('.wb-ship-fill', bar);
    var txt = $('.txt', bar);
    var pct = Math.min(100, (total / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (txt) {
      if (total >= threshold) txt.innerHTML = '<strong>✓ You\u2019ve unlocked free shipping!</strong>';
      else txt.innerHTML = 'You\u2019re <strong>' + formatMoney(threshold - total) + '</strong> away from free shipping.';
    }
  }

  function bindDrawerClose() {
    $$('.wb-drawer-close-x').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  }
  function bindDrawerLines() {
    $$('#wb-drawer-body .wb-qty').forEach(function (q) {
      var key = q.getAttribute('data-key');
      var input = $('input', q);
      $$('button', q).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10);
          var newQty = Math.max(0, parseInt(input.value, 10) + step);
          changeItem(key, newQty);
        });
      });
    });
    $$('#wb-drawer-body [data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { changeItem(b.getAttribute('data-remove'), 0); });
    });
  }

  function fetchCart() {
    return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
  }
  function changeItem(key, qty) {
    fetch(routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function addToCart(formData, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    fetch(routes.cart_add_url + '.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCart(cart);
        if (window.wbCartDrawerEnabled !== false) openDrawer(); else window.location = routes.cart_url;
      })
      .catch(function () {})
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  }

  function initCart() {
    drawer = $('#wb-cart-drawer');
    overlay = $('#wb-overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);
    $$('.wb-cart-open').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (window.wbCartDrawerEnabled === false) return; // let link go to /cart
        e.preventDefault(); openDrawer();
      });
    });
    $$('.wb-drawer-close').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    // intercept add-to-cart forms
    $$('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        addToCart(new FormData(form), btn);
      });
    });
    // refresh count on load
    if (routes.cart_url) fetchCart().then(function (cart) {
      $$('.wb-cart-count').forEach(function (b) { b.textContent = cart.item_count; b.hidden = cart.item_count === 0; });
      var bar = $('#wb-ship-bar'); if (bar) updateShipBar(cart.total_price);
    });
  }

  /* ---------- product variant picker ---------- */
  function initProduct() {
    $$('[data-product-form]').forEach(setupVariants);
    initStickyATC();
  }

  function setupVariants(root) {
    var data = $('[data-variant-json]', root);
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare]', root);
    var atcBtn = $('[data-atc]', root);
    var atcText = atcBtn ? $('span', atcBtn) || atcBtn : null;
    var optionInputs = $$('[data-option-index]', root);
    var imgMap = {};
    $$('[data-variant-image]').forEach(function () {});

    function currentOptions() {
      var opts = [];
      $$('[data-option-group]', root).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var sel = group.querySelector('.is-active, :checked, option:checked');
        var val = sel ? (sel.getAttribute('data-value') || sel.value) : null;
        opts[idx] = val;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      });
    }

    function update() {
      var opts = currentOptions();
      var v = findVariant(opts);
      // mark availability per option (basic: disable values with no available variant)
      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; if (atcText) atcText.textContent = strings.unavailable || 'Unavailable'; }
        if (idInput) idInput.value = '';
        return;
      }
      if (idInput) idInput.value = v.id;
      // url
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      } catch (e) {}
      // price
      if (priceEl) {
        priceEl.textContent = formatMoney(v.price);
        priceEl.classList.toggle('is-sale', v.compare_at_price > v.price);
      }
      if (compareEl) {
        if (v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      // availability
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      }
      // image
      if (v.featured_media && v.featured_media.id) switchImage(v.featured_media.id);
      // sticky bar
      var sp = $('#wb-sticky-price'); if (sp) sp.textContent = formatMoney(v.price);
    }

    // swatches & pills
    $$('[data-option-group]', root).forEach(function (group) {
      $$('.wb-swatch, .wb-pill', group).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          $$('.wb-swatch, .wb-pill', group).forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var label = group.parentNode.querySelector('.val');
          if (label) label.textContent = btn.getAttribute('data-value');
          update();
        });
      });
      var sel = group.querySelector('select');
      if (sel) sel.addEventListener('change', update);
    });
    update();
  }

  function switchImage(mediaId) {
    var target = document.querySelector('[data-media-id="' + mediaId + '"]');
    var main = $('#wb-pg-main-img');
    if (target && main) {
      var src = target.getAttribute('data-full') || target.querySelector('img') && target.querySelector('img').src;
      if (src) main.src = src;
      $$('.wb-pg-thumb').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(mediaId)); });
    }
  }

  /* product gallery thumbnails */
  function initGallery() {
    var main = $('#wb-pg-main-img');
    if (!main) return;
    $$('.wb-pg-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) main.src = full;
        $$('.wb-pg-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* qty steppers (product page) */
  function initQty() {
    $$('.wb-qty:not([data-key])').forEach(function (q) {
      var input = $('input', q);
      if (!input) return;
      $$('button', q).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10);
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        });
      });
    });
  }

  /* sticky add to cart */
  function initStickyATC() {
    var bar = $('#wb-sticky-atc');
    var anchor = $('#wb-buy-anchor');
    if (!bar || !anchor) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
    var btn = $('[data-sticky-atc]', bar);
    if (btn) btn.addEventListener('click', function () {
      var form = $('[data-product-form] form') || $('form[action$="/cart/add"]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.querySelector('[type=submit]').click();
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    window.wbCartDrawerEnabled = !document.body.classList.contains('wb-no-drawer');
    initHeader();
    initPredictive();
    initCart();
    initProduct();
    initGallery();
    initQty();
    window.wbOpenCart = openDrawer;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
